import { getToken } from '@chakra-ui/react'
import { initializeApp } from 'firebase/app'
import { getAuth, signInWithCustomToken } from 'firebase/auth'
import { get, getDatabase, ref } from 'firebase/database'
import { getMessaging, isSupported } from 'firebase/messaging'

import { authInstance } from '@/modules/auth'
import { localStorageInstance } from '@/modules/localStorage'
import AuthService from '@/shared/services/auth-service'

const firebaseConfig =
  import.meta.env.REACT_APP_ENV === 'prod'
    ? {
        apiKey: 'AIzaSyBEMu9nLyB4ogC6JqBfWM1vNrUiPrEdAaI',
        authDomain: 'easyaba-ce3a7.firebaseapp.com',
        databaseURL: 'https://easyaba-ce3a7-default-rtdb.firebaseio.com',
        projectId: 'easyaba-ce3a7',
        storageBucket: 'easyaba-ce3a7.appspot.com',
        messagingSenderId: '858280150193',
        appId: '1:858280150193:web:8e999e3aad8ce1159c8e90',
        measurementId: 'G-H87EH38EN5'
      }
    : {
        apiKey: 'AIzaSyATaKBdSwaO_VsfZBIxGRh687jOi0rRCOU',
        authDomain: 'easyabadebug.firebaseapp.com',
        databaseURL: 'https://easyabadebug-default-rtdb.firebaseio.com',
        projectId: 'easyabadebug',
        storageBucket: 'easyabadebug.appspot.com',
        messagingSenderId: '23725581315',
        appId: '1:23725581315:web:1beb13a89fb10396e39a36',
        measurementId: 'G-FCMY5XW85T'
      }

export const app = initializeApp(firebaseConfig)

export const database = getDatabase(app)

export const signInFirebase = async () => {
  const auth = getAuth(app)

  try {
    const token = AuthService.getPersona()?.firebaseToken ?? ''

    return await signInWithCustomToken(auth, token)
  } catch {
    const refreshToken = localStorageInstance.getUser()!.refreshToken
    const currentPersona = localStorageInstance.getPersona()
    const session = await authInstance.refresh(refreshToken)

    localStorageInstance.setUser(session)

    if (currentPersona) {
      localStorageInstance.setPersona(
        session.personaAuthenticationResponses.find(
          (persona) => persona.personaType === currentPersona.personaType
        ) ?? currentPersona
      )
    }

    const token = AuthService.getPersona()?.firebaseToken ?? ''
    return await signInWithCustomToken(auth, token)
  }
}

export const getFromFb = async <T = object>(path: string): Promise<T> => {
  const dbRef = ref(database, path)
  const dbSnap = await get(dbRef)

  return dbSnap.val()
}

const init = async () => {
  if ((await isSupported()) && window.location.protocol === 'https:') {
    const messaging = getMessaging(app) as unknown as string

    const token = {
      vapidKey:
        import.meta.env.REACT_APP_ENV === 'prod'
          ? 'BAY7EJXk8MiKhNQINpAyXSG6iGUlYpNw8jbSsRW1vUjfP7l1ih4Wbf7wBL9ykEjQFcSAqEhmQ1z4CADHkQM3s7U'
          : 'BHcIHGP4mRkMefmIGXw7q4_8p4BulAj3Pt4nF29eGRiQq03gGoEKvOxsByisHRVjdhwsljzHu2YZn3o35DR7UZg'
    } as unknown as string

    getToken(messaging, token)
  }
}

init()
